import EmbeddedFileInterface from '@app/Interface/EmbeddedFileInterface';
import * as React from 'react';

interface ArticleImageProps {
    featuredImage: EmbeddedFileInterface | null
}

const ArticleImage: React.FC<ArticleImageProps> = ({ featuredImage }) => {

    return (

        <div className="pf-u-p-lg">
            <img src={featuredImage?.media_details.sizes.medium.source_url} alt={featuredImage?.alt_text} />
        </div>

    );

}

export default ArticleImage